export const initHeaderVisibility = () => {
  const header = document.querySelector('header');
  let prevY = window.scrollY;
  const threshold = 40;
  let disableScrollHandling = false;

  const headerHidden = () => {
    if (disableScrollHandling) return;

    const currentY = window.scrollY;
    const scrollDifference = Math.abs(currentY - prevY);

    if (currentY > threshold) {
      if (currentY < prevY) {
        header.classList.remove('up-hidden');
      } else if (scrollDifference > 1) {
        // 1px以上スクロールした場合に隠す
        header.classList.add('up-hidden');
      }
    } else {
      header.classList.remove('up-hidden');
    }

    prevY = currentY;
  };

  window.addEventListener('scroll', headerHidden);
};
